import React from "react";

const StopInfoField = ({ classes, fieldName, fieldValue }) => {
  return (
    <div className={classes.flexRow}>
      <div className={classes.subHeaderText}>{fieldName} :</div>
      <div className={classes.subHeaderTextBold}>{fieldValue}</div>
    </div>
  );
};

export default StopInfoField;
